<div class="d-flex flex-column">

    <form class="form" [formGroup]="formGroup" *ngIf="formGroup">
        <div class="form-group kt-form-group row">
            <div class="col-lg-4 kt-margin-bottom-10-mobile">
                <mat-form-field class="mat-form-field-fluid">
                    <input matInput placeholder="Payment terms" name="paymentTermCnt" formControlName="payment_term" (change)="addItem($event.target.value)" type="number" ng-min="paymentTermMin" ng-max="paymentTermMax"/>
                    <mat-error *ngIf="formGroup.controls.payment_term.errors?.min || formGroup.controls.payment_term.errors?.max">
                        Value must be between {{paymentTermMin}} to {{paymentTermMax}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg-6 kt-margin-bottom-10-mobile"></div>
            <ng-container formArrayName="terms">
                <ng-container *ngFor="let termForm of terms.controls; let i = index">
                    <ng-container [formGroup]="termForm">
                        <div class="col-lg-4 kt-margin-bottom-10-mobile mb-3 mt-3">
                            <mat-form-field class="mat-form-field-fluid" [formFieldState]="termForm.controls['percent']">
                                <input matInput [placeholder]="termForm.controls.title.value" formControlName="percent" mask="percent" suffix="%"/>
                                <mat-hint [formFieldHintState]="formGroup.controls['percent']">
                                    Percent
                                    <span>required</span>
                                </mat-hint>
                                <mat-error>
                                    Percent
                                    <strong>required</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg-4 kt-margin-bottom-10-mobile" *ngIf="pricingStrategy != 6">
                            <mat-form-field class="mat-form-field-fluid mt-3" [formFieldState]="termForm.controls['payment_date']">
                                <mat-datepicker #addPicker_payment_date></mat-datepicker>
                                <kt-datepicker-tz-input
                                    #paymentDatePicker
                                    [placeholder]="termForm.controls.title.value.replace('-', ' Date-')"
                                    [timezone]="timezoneOffset"
                                    formControlName="payment_date"
                                ></kt-datepicker-tz-input>
                                <button mat-button mat-icon-button matSuffix type="button">
                                    <mat-icon>today</mat-icon>
                                </button>
                                <button mat-button mat-icon-button matSuffix type="button" (click)="clearDate(i)">
                                    <mat-icon>close</mat-icon>
                                </button>
                                <mat-hint [formFieldHintState]="termForm.controls['payment_date']">
                                    Payment Date
                                    <span>required</span>
                                </mat-hint>
                                <mat-error>
                                    Payment Date
                                    <strong>required</strong>
                                </mat-error>
                            </mat-form-field>
                        </div> -->
                        <ng-container *ngIf="pricingStrategy == 6">
                            <div class="col-lg-4 kt-margin-bottom-10-mobile" *ngIf="i != 0">
                                <mat-form-field class="mat-form-field-fluid mt-3">
                                    <input matInput formControlName="days_from_cdc" placeholder="Days from CDC" 
                                        mask="separator"
                                    />
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4 kt-margin-bottom-10-mobile" *ngIf="i == 0"></div>
                        </ng-container>
                        <div class="col-lg-4 kt-margin-bottom-10-mobile"></div>
                    </ng-container>
                </ng-container>
                <div class="col-md-12 kt-margin-bottom-20-mobile">
                    <mat-error class="tag-custom-error tag-custom-margin-top-10" *ngIf="terms.length == 0">
                        Payment terms cannot be 
                    </mat-error>
                    <mat-error class="tag-custom-error tag-custom-margin-top-10" *ngIf="terms.length > 0 && termsPercent != 100">
                        The total payment terms should equal 100%. It is currently: <strong>{{termsPercent}}</strong>
                    </mat-error>
                    <!-- <mat-error class="tag-custom-error tag-custom-margin-top-10" *ngIf="terms.length > 1 && termsPercent == 100 && !paymentDateValid">
                        {{message}}
                    </mat-error> -->
                </div>
            </ng-container>
        </div>
    </form>
</div>